var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "awardItem", class: "rarity-" + _vm.rarity },
    [
      _c("div", { staticClass: "awardItem-top" }, [
        _c("div", { staticClass: "rate-item flex flex-ver" }, [
          _vm.rate
            ? _c("div", { staticClass: "rate flex flex-center-1" }, [
                _vm._v(" " + _vm._s(_vm.rate) + " %"),
              ])
            : _vm._e(),
        ]),
        _c(
          "div",
          { staticClass: "awardItem-pic-1 flex flex-center-1" },
          [
            _c("div", { staticClass: "itemimg" }, [
              _c("img", { attrs: { src: _vm.$imgfilter(_vm.picture) } }),
            ]),
            _c("c-svg", {
              staticClass: "itembg",
              attrs: {
                src: "itembg.svg",
                svgShadow: _vm.svgShadow,
                fill: "rgb(255, 255, 255,.2)",
              },
            }),
          ],
          1
        ),
      ]),
      _c("div", { staticClass: "awardItem-bottom" }, [
        _c("div", { staticClass: "item-name-con" }, [
          _c("div", { staticClass: "item-name flex flex-col flex-ver" }, [
            _c("div", { staticClass: "skin-name" }, [
              _vm._v(_vm._s(_vm._f("GetItemSkinName")(_vm.name))),
            ]),
            _c("p", { staticClass: "weapon-name-item" }, [
              _vm._v(
                " " +
                  _vm._s(_vm._f("getBrackets")(_vm.name)) +
                  " " +
                  _vm._s(_vm._f("getFirstName")(_vm.name)) +
                  " "
              ),
            ]),
          ]),
        ]),
        _c("div", { staticClass: "price-item flex flex-center-1" }, [
          _c("img", {
            staticClass: "icon",
            attrs: {
              src: require("../../assets/images/home_new/KJ_currency.png"),
            },
          }),
          _c("p", { staticClass: "userInfo-price-p" }, [
            _vm._v(" " + _vm._s(_vm.price) + " "),
          ]),
        ]),
      ]),
      _c("div", { staticClass: "item-info" }, [
        _c("div", { staticClass: "item-info-item" }, [
          _c("p", { staticClass: "title" }, [_vm._v("磨损")]),
          _c("p", { staticClass: "item" }, [
            _vm._v(_vm._s(_vm._f("GetItemDuration")(_vm.name))),
          ]),
        ]),
        _c("div", { staticClass: "item-info-item" }, [
          _c("p", { staticClass: "title" }, [_vm._v("价格")]),
          _c("div", { staticClass: "item flex flex-ver" }, [
            _c("img", {
              staticClass: "icon",
              attrs: {
                src: require("../../assets/images/home_new/KJ_currency.png"),
              },
            }),
            _c("p", { staticClass: "userInfo-price-p" }, [
              _vm._v(" " + _vm._s(_vm.price) + " "),
            ]),
          ]),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }